import React, { useEffect, useRef, useState } from 'react'
import { intersection_threshold, url } from '../../base/Variables'
import { catchError, LazyAxios } from '../../base'
import { ReviewData } from '../index'


const ShopAnalytics = React.memo(({ shop_id, setPerror, setShopDetail }) => {
    const [loading, setLoading] = useState(true)
    const [shopAnalytics, setShopAnalytics] = useState(null)
    const componentRef = useRef(null)

    async function getShopAnalytics() {
        try {
            setLoading(true)
            const axios = await LazyAxios()
            const request = await axios.get(`${url}/api/v1/shop/${shop_id}/analytics/`)
            if (request.data && request.data.data) {
                setShopAnalytics(request.data.data)
            }
            else if (request.data && request.data.shop === null) {
                setShopDetail(null)
            }
            setLoading(false)
        }
        catch (error) {
            setLoading(false)
            setPerror(catchError(error).error_message)
        }
    }

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                // Check if the child component is in the viewport
                if (entries[0].isIntersecting && loading) {
                    // Trigger the API call or any function passed as prop
                    if (shop_id) {
                        getShopAnalytics()
                    }
                    else {
                        setLoading(false)
                    }
                }
            },
            {
                root: null, // default to the viewport
                threshold: intersection_threshold, // 40% of the component must be visible
            }
        );

        if (componentRef.current) {
            observer.observe(componentRef.current);
        }

        return () => {
            if (componentRef.current) {
                observer.unobserve(componentRef.current);
            }
        };
    }, [shop_id, loading])

    console.log(shopAnalytics)
    return (
        <>
            <div className='shopAnalytics' style={loading ? { minHeight: '900px' } : {}} ref={componentRef}>
                {
                    shopAnalytics && <>
                        <div className='h4 pcolor stylishFont text-center mb-4' style={{ textDecoration: 'underline' }}>More About Our Shop</div>
                        <div className='record mb-5'>
                            <div className='single mt-3 mt-md-3'>
                                <h6 className='h4 stylishFont pcolor'>{shopAnalytics.total_product} +</h6>
                                <h6 className='h6'>Total Products</h6>
                            </div>
                            <div className='single mt-3 mt-md-3'>
                                <h6 className='h4 stylishFont pcolor'>{shopAnalytics.total_order} +</h6>
                                <h6 className='h6'>Orders Completed</h6>
                            </div>
                            <div className='single mt-3 mt-md-3'>
                                <h6 className='h4 stylishFont pcolor'>{shopAnalytics.total_product_sold} +</h6>
                                <h6 className='h6'>Product Sold</h6>
                            </div>
                        </div>
                        <ReviewData id={shop_id} page={'shop'} setPerror={setPerror} setParentData={setShopDetail} total_review={shopAnalytics.total_review} avg_rating={shopAnalytics.avg_rating} />
                    </>
                }

            </div>
            <hr />
        </>
    )
})

export default ShopAnalytics